import Promise from 'bluebird';
import _ from "lodash";

import { pinBuilder } from '../core/map/pinBuilder';
import templates from '../core/templates';
import ColorBrewer from '../core/tools/colorbrewer';
import environment from '../environment';
import Leaflet from './Leaflet';
import streetView from '../core/map/streetview';

class TollLayer {
    constructor (currentMap) {
        const clusterImage = new Image();
        clusterImage.src = `${environment.get('IMAGES_HOST')}/icon_marker_toll.png`;

        const onClick = (feature, layer) => {
            createPopupTemplate(feature, layer);
        };

        const clusterTemplate = cluster => {
            const data = {
                value: cluster.getAllChildMarkers().length,
            };

            if (currentMap.getZoom() < 14) {
                return pinBuilder.create.pin.imageWithValue(data, clusterImage);
            } else {
                return pinBuilder.create.pin.cluster(data);
            }
        };

        const createPopupTemplate = (properties, layer) =>
            new Promise((resolve, reject) => {
                const $template = $(templates('map-layer-toll-popup', properties));
                const coordinates = {
                    lat: properties.geometry.coordinates[1],
                    lng: properties.geometry.coordinates[0]
                };
                streetView.thumbnailStreetView($template.find('.leaflet-popup-image'), coordinates)
                    .then(() => {
                        resolve($template);
                    });
            });

        return new Leaflet.GeoJSONLayer({
            map: currentMap,
            id: `spatial_toll_layer`,
            remote: {
                method: 'GET',
                url: `${environment.get('API_HOST')}/Layer/GetTolls`,
                params: { }
            },
            scaleRange: [5, 20],
            showAll: true,
            autofocus: false,
            uniqueField: 'Id',
            sort: 'NameToll',
            click: onClick,
            popup: {
                template: createPopupTemplate,
                trigger: 'mouseover',
                options: {
                    offset: L.point(0, -50),
                    closeButton: false,
                    autoclose: true
                },
                single: true
            },
            type: 'cluster',
            symbology: {
                type: 'polymorph',
                cluster: {
                    disableAtZoom: 20,
                    template: clusterTemplate
                },
                heat: {
                    theme: ColorBrewer.getHeatColors(ColorBrewer.RED_YELLOW_GREEN)
                },
                style: {
                    icon: {
                        iconUrl: `${environment.get('IMAGES_HOST')}/pin_toll.png`,
                        iconSize: [50, 64],
                        iconAnchor: [25, 60],
                        labelAnchor: [18, 9]
                    },
                    riseOnHover: true
                }
            }
        });
    }
}

export default TollLayer;



// WEBPACK FOOTER //
// ./src/scripts/layers/TollLayer.js